import { useNavigate } from 'react-router-dom';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { FeatureSteps } from './ui/FeatureSteps';

const features = [
    {
        step: "01",
        title: "Discovery",
        content: "We dive deep into your business to identify high-impact opportunities for automation.",
        image: "/journey/discovery.png"
    },
    {
        step: "02",
        title: "Strategy",
        content: "We design a bespoke agentic architecture tailored to your specific goals and workflows.",
        image: "/journey/strategy.png"
    },
    {
        step: "03",
        title: "Execution",
        content: "Our engineers build and deploy intelligent agents that seamlessly integrate with your systems.",
        image: "/journey/execution.png"
    },
    {
        step: "04",
        title: "Extended Partnership",
        content: "We act as an extension of your team, constantly identifying and implementing new automations to drive continuous improvement.",
        image: "/journey/partnership.png"
    },
];

const ServicesSection = () => {
    const navigate = useNavigate();
    const header = useScrollReveal();

    return (
        <section id="services" className="py-24 bg-background relative overflow-hidden scroll-mt-32 section-glow">
            <div className="container px-4 md:px-6 relative z-10">
                <div
                    ref={header.ref}
                    className={`text-center mb-10 ${header.isVisible ? 'animate-reveal-up' : 'opacity-0'}`}
                >
                    <h2 className="text-4xl md:text-6xl font-bold mb-6 tracking-[-0.05em] leading-[1.1]">
                        The journey to <span className="text-primary/50">autonomy</span>
                    </h2>
                    <p className="text-muted-foreground max-w-xl mx-auto text-lg font-light leading-relaxed">
                        A seamless flow from idea to intelligent enterprise.
                    </p>
                </div>

                <FeatureSteps
                    features={features}
                    title=""
                    autoPlayInterval={4000}
                    imageHeight="h-[400px]"
                />

                {/* CTA */}
                <div className="mt-16 text-center">
                    <button
                        onClick={() => navigate('/contact-us')}
                        className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-primary text-primary-foreground font-semibold text-lg hover:scale-105 active:scale-95 transition-all shadow-xl shadow-primary/10"
                    >
                        Start Your Journey
                    </button>
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;
